import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'dskhome-footer-icons',
  templateUrl: './footer-icons.component.html',
  styleUrls: ['./footer-icons.component.scss'],
  imports: [MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterIconsComponent {}
